export default function Fleet() {
  const vans = [
    {
      title: 'Small Van',
      image: 'https://static.readdy.ai/image/ab43357bf771d1fcf31d3399e10c2db6/07ce43a3fc966e23a6000d0aae873c4a.jpeg',
    },
    {
      title: 'Medium Van',
      image: 'https://static.readdy.ai/image/ab43357bf771d1fcf31d3399e10c2db6/47303abc346342a6476517520d5913e4.png',
    },
    {
      title: 'Large Van',
      image: 'https://static.readdy.ai/image/ab43357bf771d1fcf31d3399e10c2db6/b8a87b3b2a3ed5112e67985b0fca3aea.png',
    },
    {
      title: 'Luton Van',
      image: 'https://static.readdy.ai/image/ab43357bf771d1fcf31d3399e10c2db6/9811d3848a530edd63278ae4fe752bb9.jpeg',
    },
  ];

  return (
    <section id="fleet" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Our Fleet</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Modern, well-maintained vehicles to suit every moving need. All our vans are fully insured and equipped with professional moving equipment.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {vans.map((van, index) => (
            <div 
              key={index}
              className="bg-gray-700 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="h-48 w-full overflow-hidden">
                <img 
                  src={van.image}
                  alt={van.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white text-center">{van.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
